import React from "react"
import MatchCard from "./MatchCard"

// P54 — the Tenis10 small final (t10-clasament: `mainDraw.thirdPlaceMatch`, a phase match at the semi-final round, position 3,
// `competition.thirdPlace`). The phase rounds do not hold it, so it has its own section under the final phase, one bracket card
// wide; until both semi-finals have a result its sides are the two losers to come. Its score opens the phase's Edit match dialog.
export default function ThirdPlaceMatch({ match, competitionDetails, eventDetails, setModal, matches }) {
  if (!match) return null
  const title = "Third-place match"
  return <section className="main-draw-third-place mb-4" aria-label="Small final">
    <h3>Small final · 3rd place</h3>
    <div style={{ maxWidth: 384 }}>
      {match.type === "TBA"
        ? <article className="main-draw-match main-draw-tba" aria-label={title}>
          <strong>{title}</strong>
          <span>Loser of semi-final 1 · Loser of semi-final 2</span>
        </article>
        : <MatchCard row={match} label={title} title={title} index={(match.competition?.position || 3) - 1}
          {...{ competitionDetails, eventDetails, setModal, matches }} />}
    </div>
  </section>
}
